import service from '@/services/restaurant/restaurant'

const getDefaultState = () => ({
  restaurant: { name: '', location: '', state: true },
  cajaSeleccionada: {},
  list: [],
  currentRow: null,
  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.restaurant = { ...getDefaultState().restaurant }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET: (state, obj) => {
    state.restaurant = obj
    state.saved = true
  },
  SET_LIST: (state, obj) => (state.list = obj),
  SET_CAJA: (state, obj) => (state.cajaSeleccionada = obj),
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, { obj }) => {
    state.list = state.list.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.restaurant = obj
    state.saved = false
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, input) => {
    return service
      .create({
        ...input,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          _id: result._id
        })

        return result
      })
  },

  readById: async ({ commit, state }, input) => commit('SET', input),
  // resetList: ({ state }) => (state.list = []),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, force = false) => {
    if (state.list.length && !force) return state.list

    state.list = []

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      // setea el primer restaurante como default.
      if (result.length)
        commit(
          'restaurant/orderStore/SET_OPTIONS',
          {
            restaurant: result[0]._id,
            zone: '',
            table: '',
            category: '',
            // checkOtrosCargos: false,
            // print: null
          },
          { root: true }
        )

      commit('SET_LIST', result)

      return true
    })
  },
  delete: ({ commit }, { items }) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i })
      })
      return result
    }),

  saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}
